import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IEmptyProps = IContainerProps;

export const Empty: React.FC<IEmptyProps> = (props) => {
  const { sx } = props;

  return <div {...stylex.props(sx)}>—</div>;
};
